export default function Faq() {
    const faqContainer = document.querySelectorAll('.faq-block__body');
    const faqContainerExt = document.querySelectorAll('.faq-block-ext__body');

    const combinedFaqContainer = [
        ...faqContainer,
        ...faqContainerExt
    ];

    if (combinedFaqContainer) {
        combinedFaqContainer.forEach(function (el) {
            el.addEventListener('click', function (e) {
                const items = el.querySelectorAll('.faqs-btn')
                const target = e.target
                Array.from(items).forEach(item => {
                    if (item != target) {
                        item.classList.remove('show')
                    }
                })
                target.classList.toggle('show')
            })
        });
    }
}